import config from "./config";

export const APP_VERSION = config.appVersion;

//common config
export const WEBNAME = config.webName;
export const ADDRESS = config.address;
export const EMAIL = config.email;
export const MOBILE = config.mobile;
export const WHATSAPP = config.whatsapp;
export const NO_IMAGE = config.noImage;
export const DEVS_SITE = config.devsSite;
export const STORE_WEB_LINK = config.storeWebLink;

//keys
export const SESSION_STORAGE_KEY = config.sessionStorageKey;
export const PANEL_STORAGE_KEY = config.panelStorageKey;
export const BILLING_LAYOUT_KEY = config.BILLING_LAYOUT_KEY;
export const BILL_TYPE_KEY = config.BILL_TYPE_KEY;
export const PANEL_VIEW_KEY = config.PANEL_VIEW_KEY;
export const KOT_PRINTER_SERVER = config.kotPrinterServer;

//env config
export const WEB_URL = config.webLink;
export const SERVER = config.server;
export const SERVER_API = config.serverapi;
export const IMAGE_URL = config.imagepath;
export const USERGUIDE_URL = config.userGuideUrl;

//system route
export const ROUTE = {
  //web route
  login: config.login,
  loginSuccess: config.loginSuccess,
  forgotPassword: config.forgotPassword,

  //system route
  dashboard_overview: config.dashboard_overview,
  sales_billing: config.sales_billing,
  sales_return: config.sales_return,
  sales_history: config.sales_history,
  sales_expenses: config.sales_expenses,
  sales_cheques: config.sales_cheques,
  sales_quotation: config.sales_quotation,
  product_manage: config.product_manage,
  stock_adjustment: config.stock_adjustment,
  stock_history: config.stock_history,
  purchase_manage: config.purchase_manage,
  raw_material_manage: config.raw_material_manage,
  raw_material_purchase: config.raw_material_purchase,
  recipe_manage: config.recipe_manage,
  production_manage: config.production_manage,
  stock_transfer: config.stock_transfer,
  supplier_manage: config.supplier_manage,
  customer_manage: config.customer_manage,
  credits_summery: config.credits_summery,
  customer_ledger: config.customer_ledger,
  supplier_ledger: config.supplier_ledger,
  report_sales: config.report_sales,
  report_inventory: config.report_inventory,
  report_purchase: config.report_purchase,
  report_expenses: config.report_expenses,
  report_credit: config.report_credit,
  report_others: config.report_others,

  employee_manage: config.employee_manage,
  attendance_manage: config.attendance_manage,
  payroll_manage: config.payroll_manage,
  leave_manage: config.leave_manage,
  user_manage: config.user_manage,
  store_manage: config.store_manage,

  repair_jobs: config.repair_jobs,
  courier_manage: config.courier_manage,
  monthly_attendance_sheet: config.monthly_attendance_sheet,
  store_live_tracking: config.store_live_tracking,
  barcode_editor: config.barcode_editor,
  access_policies: config.access_policies,
  bank_manage: config.bank_manage,
  whatsapp_chatbot: config.whatsapp_chatbot,
  online_orders: config.online_orders,
  web_info: config.web_info,
  ad_campaigns: config.ad_campaigns,
  ad_list: config.ad_list,
  ad_detail: config.ad_detail,
  system_admin_tenants: config.system_admin_tenants,
};

export const REPORT = {
  sales_ledger: config.report.sales_ledger,
  item_profit: config.report.item_profit,
  cash_flow: config.report.cash_flow,
  cheques: config.report.cheques,
  discounts: config.report.discounts,
  non_cash_payments: config.report.non_cash_payments,
  employee_performance: config.report.employee_performance,
  sign_off_list: config.report.sign_off_list,
  sign_off_detail: config.report.sign_off_detail,
  product_stock: config.report.product_stock,
  expiring_items: config.report.expiring_items,
  purchases: config.report.purchases,
  purchased_products: config.report.purchased_products,
  returned_items: config.report.returned_items,
  sold_items: config.report.sold_items,
  by_cashier: config.report.by_cashier,
  total_items: config.report.total_items,
  products: config.report.products,
  purchase_returns: config.report.purchase_returns,
  purchase_payments: config.report.purchase_payments,
  expense_by_seller: config.report.expense_by_seller,
  debtors: config.report.debtors,
  creditors: config.report.creditors,
  customers: config.report.customers,
  suppliers: config.report.suppliers,
  raw_stock_issue: config.report.raw_stock_issue,
  raw_material_purchases: config.report.raw_material_purchases,
  productions: config.report.productions,
  transfers: config.report.transfers,
};

//commons
export const APPLOGO = config.appLogo;
export const SIGNIN_BG = config.signInBg;
export const PAGE_SIZE = 10;
export const DEBOUNCED_SEARCH_QUERY = 300;
export const MIN_PASSWORD_LENGTH = 4;
export const UNAUTHORIZED_EVENT = "auth:unauthorized";

export const INVOICE_TEMPLATES = [
  { value: "classic" as const, label: "Classic" },
];
export const INVOICE_PAGE_SIZES = [
  { value: "A4" as const, label: "A4 Paper" },
  { value: "A3" as const, label: "A3 Paper" },
  { value: "80mm" as const, label: "80mm POS" },
];

// React Query stale time constants
export const DEFAULT_STALE_TIME = 30 * 1000;
export const LOOKUP_STALE_TIME = 10 * 60 * 1000;
export const STALE_TIME_1_MIN = 60 * 1000;
export const STALE_TIME_5_MIN = 5 * 60 * 1000;
export const STALE_TIME_0 = 0;

// System Config Cache Constants
export const SYSTEM_CONFIG_CACHE_KEY = "system_config_cache";
export const SYSTEM_CONFIG_CACHE_TS_KEY = "system_config_cache_ts";
export const SYSTEM_CONFIG_CACHE_DURATION = 24 * 60 * 60 * 1000;
export const AD_POPUP_VISIBLE_MS = 10 * 1000;
export const AD_POPUP_DELAY_MS = 60 * 1000;
export const AD_ROTATION_INTERVAL_MS = 10 * 60 * 1000;
export const AD_MAX_PER_DAY = 20;
export const SEEN_ADS_STORAGE_KEY = "lastShownAdDates";
